var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2954 28.5756C60.2954 36.9403 54.9356 43.4986 49.4577 48.9808C43.9755 54.463 37.4172 60 29.0525 60C20.6879 60 12.4372 56.1511 6.95927 50.6731C1.48133 45.1952 0 36.9403 0 28.5756C0 20.211 1.38848 11.8675 6.86643 6.38953C12.3444 0.911585 20.6921 0 29.0568 0C37.4214 0 44.693 1.97932 50.1709 7.46149C55.6489 12.9437 60.2954 20.211 60.2954 28.5756Z",
    fill: "#807BE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3875 15.7389C22.3875 17.3305 21.2119 18.6207 19.279 18.6207C17.4608 18.6182 16.2852 17.3305 16.2852 15.7389C16.2852 14.1075 17.4982 12.8571 19.3563 12.8571C21.2119 12.8571 22.3502 14.1075 22.3875 15.7389ZM16.4371 39.4285V20.8923H22.1982V39.4285H16.4371Z",
    fill: "#1E1010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6461 26.8053C25.6461 24.4939 25.5714 22.5611 25.4941 20.8923H30.4981L30.7646 23.4702H30.8792C31.6364 22.2572 33.4945 20.4763 36.6029 20.4763C40.3939 20.4763 43.2358 23.0169 43.2358 28.4741V39.4285H37.4747V29.1566C37.4747 26.768 36.6403 25.139 34.5555 25.139C32.9639 25.139 32.0174 26.2374 31.599 27.2985C31.4471 27.6771 31.4097 28.2076 31.4097 28.7382V39.4285H25.6461V26.8053Z",
    fill: "#1E1010"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.2954,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.558bbf9ec377ef7937bd71eb599bc55c.svg";
export { ForwardRef as ReactComponent };